function hasHover() {
    return ENVIRONMENT_TYPE === ENVIRONMENT_TYPES.CLIENT ? matchMedia('(hover: hover)').matches : true;
}
export default hasHover;
